import { z } from 'zod';

import { StepColorEnum } from '../../enums';

export const CreateWordGroupSchema = z.object({
  color: z
    .nativeEnum(StepColorEnum)
    .default(StepColorEnum.ROYAL_BLUE)
    .optional(),
  description: z.string().max(255, 'Description is too long').optional(),
  lastDate: z.date().nullable().optional(),
  name: z.string().min(1, 'Name cannot be empty').max(64, 'Name is too long'),
  nextDate: z.date().nullable().optional(),
});

export type ICreateWordGroupDto = z.infer<typeof CreateWordGroupSchema>;
